import { Ref } from "@tblabs/truffle";
import { Svg } from "../../Pages/Components/Utils/Svg";


export class SvgButton extends Svg
{
    constructor(svgAsText: string | Ref<string>, onClick?: () => void)
    {
        super(svgAsText);
        this.Class("SvgButton")

        if (onClick)
            this.OnClick(onClick)
    }
}
